import data from "../../.sourceflow/quote.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const quotes_helper = new CollectionHelper(data);
